import { render, staticRenderFns } from "./Parseword.vue?vue&type=template&id=65083424&scoped=true"
import script from "./Parseword.js?vue&type=script&lang=js&external"
export * from "./Parseword.js?vue&type=script&lang=js&external"
import style0 from "./Parseword.scss?vue&type=style&index=0&id=65083424&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65083424",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingSpinner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/LoadingSpinner.vue').default,HintsSection: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/wordle/HintsSection.vue').default,AnswerSection: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/wordle/AnswerSection.vue').default,ParsewordArchiveList: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/ParsewordArchiveList/ParsewordArchiveList.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
